<template>
  <div class="layout_containner_item" :style="{ height: height }">
    <slot></slot>
    <div class="layout_containner_item_b"></div>
  </div>
</template>

<script>
export default {
  props: ["height"],
};
</script>

<style lang='scss' scoped>
.layout_containner_item {
  // width: 100vw;
  // height: 100vh;
}
</style>